import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'eos-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss']
})
export class MyProfileComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
